<template>
  <div v-if="$can(this.can, this.on) || $can('manage', 'all')">
    <slot />
  </div>
</template>
<script>

// import { mapGetters } from 'pinia';

export default {
  name: 'Permite',

  props: {
    can: {
      type: String,
      required: true,
    },
    on: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      admin: false,
    };
  },
};
</script>
